@if (rows && rows.length > 0) {
  <div>
    <ng-container>
      <div class="inline-block min-w-full align-middle sm:px-6 lg:px-8">
        <table class="min-w-full divide-y divide-gray-300">
          <thead>
            <tr class="divide-x divide-gray-200">
              @for (header of tableHeaders; track header) {
                <th scope="col"
                  class="py-3.5 pl-4 pr-4 text-left text-base font-semibold text-black">
                  {{ header.display | translate }}
                </th>
              }
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            @for (discrepancy of rows; track discrepancy) {
              <tr class="divide-x divide-gray-200"
                >
                <td class="py-4 pl-4 pr-4 text-lg font-bold text-th-primary ">
                  {{ discrepancy.description | translate }}
                </td>
                <td class="p-4 text-lg ">
                  @if (discrepancy?.status === 'discrepant') {
                    <span class="inline-flex items-center gap-x-1.5 rounded-md bg-red-100 px-2 py-1 text-base font-bold text-red-700"
                      >
                      {{ discrepancy.initialValue }}
                    </span>
                  }
                  @if (discrepancy?.status === 'congruent') {
                    <span class="inline-flex items-center gap-x-1.5 rounded-md bg-gray-100 px-2 py-1 text-base font-bold text-black"
                      >
                      {{ discrepancy.initialValue }}
                    </span>
                  }
                </td>
                <td class="p-4 text-base ">
                  @if (discrepancy?.status==='congruent') {
                    <span class="inline-flex items-center gap-x-1.5 rounded-md bg-gray-100 px-2 py-1 text-base font-bold text-black"
                      >
                      {{ discrepancy.deltaValue }}
                    </span>
                  }
                  @if (discrepancy?.status==='discovered') {
                    <span class="inline-flex items-center gap-x-1.5 rounded-md bg-yellow-100 px-2 py-1 text-base font-bold text-yellow-700"
                      >
                      {{ discrepancy.deltaValue }}
                    </span>
                  }
                  @if (discrepancy?.status === 'discrepant') {
                    <span
                      class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-base font-bold bg-red-100 text-red-700">
                      {{ discrepancy.deltaValue }}
                    </span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="flex flex-row mt-4 ml-4 gap-x-5">
        @if (!hideDiscovered) {
          <span
            class="inline-flex items-center gap-x-1.5 rounded-md bg-yellow-100 px-2 py-1 text-base font-bold text-yellow-700">
            <svg class="h-1.5 w-1.5 fill-yellow-500"
              viewBox="0 0 6 6"
              aria-hidden="true">
              <circle cx="3"
                cy="3"
                r="3" />
              </svg>
              Discovered
            </span>
          }
          <span
            class="inline-flex items-center gap-x-1.5 rounded-md bg-red-100 px-2 py-1 text-base font-bold text-red-700">
            <svg class="h-1.5 w-1.5 fill-red-500"
              viewBox="0 0 6 6"
              aria-hidden="true">
              <circle cx="3"
                cy="3"
                r="3" />
              </svg>
              Discrepancies found
            </span>
          </div>
        </ng-container>
      </div>
    }